import { Swiper, Pagination, Navigation } from 'swiper';
import 'swiper/scss';

Swiper.use(Pagination);
Swiper.use(Navigation);

class CarouselCard extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.$items = this.querySelector('.js-carousel-card__items');
    this.$prevBtn = this.querySelector('.js-carousel-card__prev');
    this.$nextBtn = this.querySelector('.js-carousel-card__next');
    this.$pagination = this.querySelector('.js-carousel-card__pagination');
    if (this.$items) this.setupCarousel();
  }

  setupCarousel() {
    this.carousel = new Swiper(this.$items, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: this.$nextBtn,
        prevEl: this.$prevBtn,
      },
      pagination: {
        el: this.$pagination,
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
      },
    });
  }
}

export default function init() {
  customElements.define('carousel-card', CarouselCard);
}
